import axios from 'axios'
import qs from 'qs'

const REQ_FAIL = '服务端异常'
const TIMEOUT = '请求超时'

// 设置 7 秒超时
const timeout = reject =>
  setTimeout(() => reject(TIMEOUT), 10e3)

export default {
  // 获取平台列表
  getPlatform () {
    const url = '/dashboard/app/platform'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
        .catch(e => reject(REQ_FAIL))
      timeout(reject)
    })
  },
  // 获取分类列表
  getCategory () {
    const url = '/dashboard/app/category'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
        .catch(e => reject(REQ_FAIL))
      timeout(reject)
    })
  },
  //判断是否受限
  getLimit(){
    const url = '/dashboard/app/count/limit'
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
        .catch(e => reject(REQ_FAIL))
      timeout(reject)
    })
  },
  // 创建应用
  create (params) {
    const url = '/dashboard/app/create'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
        .catch(e => reject(REQ_FAIL))
      timeout(reject)
    })
  },
  // 应用名称是否存在
  isAppNameExist (params) {
    const url = encodeURI('/dashboard/app/is-appname-exist?appName=' + params.appName)
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
        .catch(e => reject(REQ_FAIL))
      timeout(reject)
    })
  },
  getAppInfo (appId) {
    const url = '/dashboard/app/info/' + appId
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(resp => resolve(resp.data))
        .catch(e => reject(REQ_FAIL))
      timeout(reject)
    })
  },
  updateAppInfo (params) {
    const url = '/dashboard/app/update'
    return new Promise((resolve, reject) => {
      axios.post(url, qs.stringify(params))
        .then(resp => resolve(resp.data))
        .catch(e => reject(REQ_FAIL))
      timeout(reject)
    })
  }

}



// WEBPACK FOOTER //
// ./app/api/create.js